import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DistrictService {

  constructor(private  httpClient: HttpClient) {
  }

  getDistricts() {
    return this.httpClient.get('/systemconfig/district/');
  }

  ///////////////old/////////////
  getDistrict(id) {
    return this.httpClient.get(`/systemconfig/district/${id}/`);
  }

  getdistricts(id){
    return this.httpClient.get('/systemconfig/districts/',{params : {id:id}})
  }

  postDistrict(district) {
    return this.httpClient.post('/systemconfig/district/', district);
  }

  ///////////////old///////////
  updateDistrict(id, district) {
    return this.httpClient.patch(`/systemconfig/district/${id}/`, district);
  }

  updatedistrict(district){
    return this.httpClient.post('/systemconfig/districts/',district)
  }
    postDistrictFile(file) {
    return this.httpClient.post('/systemconfig/importdistrict/', file);
  }
  checkDistrict(district){
    return this.httpClient.get('/systemconfig/checkdistrict/?district='+ district);
  }

  getDistrictData(state){
    return this.httpClient.get('/systemconfig/getdistrictdata/?state='+ state);
  }
}
